import { Exception } from '@core/exceptions/exception';

export class ActivatedRouteTypeParamMismatchException extends Exception {
  constructor(message = 'Type mismatch.') {
    super(message);
  }
}
